export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

/**
 * @param choice number
 * @param choicesLength number
 * http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html#pl
 */
export function pluralizationRules(choice, choicesLength) {
  let result = 3; //many
  if (choice === 0) {
    return 0; //Special case zero
  }

  const teen = (choice % 100) > 10 && (choice % 100) < 20;
  const digit = choice % 10;

  if (digit === 1) {
    result = 1; //one
  }

  if (!teen && digit >= 2 && digit <= 4) {
    result = 2; //few
  }

  return Math.min(result, choicesLength - 1);
};

export const messages = {
    "login.form.title": "Zaloguj się",
    "login.form.hint.user": "Nazwa logowania",
    "login.form.hint.password": "Hasło",
    "login.form.checkbox.remember-me": "Zapamiętaj mnie",
    "login.form.button.sign-in": "Zaloguj się",
    "login.form.message.invalid-user-credentials": "Nazwa logowania lub hasło są niepoprawne",
    "login.form.message.user-required": "Wprowadź nazwę logowania",
    "login.form.message.password-required": "Wprowadź hasło",
    "login.form.button.forgot-password": "Nie pamiętasz hasła?",
    "error.root-admin-login.title": "Błąd 403 — dostęp wzbroniony",
    "error.root-admin-login.message": "Zalogowano się jako administrator Tylko do odczytu. Aby uzyskać dostęp do konsoli Web Recovery, zaloguj się jako dzierżawca-klient lub administrator"
};
